export const translation = {
    error: 'Error',
};
